(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml_section-create-form"] && !Shopify.designMode) return;
  try {
    
  const centerCreateForm = (embed) => {
    const root = embed.shadowRoot;
    if (!root || root.querySelector('[data-ml-form-center]')) return;

    const style = document.createElement('style');
    style.dataset.mlFormCenter = 'true';
    style.textContent = [
      '[class*="formContainer"] { margin-inline: auto !important; }',
      '[class*="formHeader"] [class*="textHeading"] { text-align: center !important; }',
    ].join(' ');
    root.appendChild(style);
  };

  const watchCreateForm = (embed) => {
    if (embed.dataset.mlFormCenterWatched === 'true') {
      centerCreateForm(embed);
      return;
    }

    embed.dataset.mlFormCenterWatched = 'true';

    const bind = () => {
      centerCreateForm(embed);
      if (!embed.shadowRoot || embed.dataset.mlFormCenterObserving === 'true') return Boolean(embed.shadowRoot);

      embed.dataset.mlFormCenterObserving = 'true';
      new MutationObserver(() => centerCreateForm(embed)).observe(embed.shadowRoot, {
        childList: true,
        subtree: true,
      });
      return true;
    };

    if (bind()) return;

    const started = Date.now();
    const timer = setInterval(() => {
      if (bind() || Date.now() - started > 10000) clearInterval(timer);
    }, 200);
  };

  const watchCreateForms = () => {
    document.querySelectorAll('.ml_class-create-form shopify-forms-embed').forEach(watchCreateForm);
  };

  watchCreateForms();
  new MutationObserver(watchCreateForms).observe(document.body, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml_section-inspiration-gallery"] && !Shopify.designMode) return;
  try {
    
  class MlInspirationGallery extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.track = this.querySelector('[data-track]');
      this.index = 0;
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.go(index));
      });
    }

    go(index) {
      if (!this.slides.length || !this.track) return;
      this.index = index;
      this.track.style.transform = `translateX(${index * -100}%)`;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
        dot.tabIndex = active ? 0 : -1;
      });
    }
  }

  if (!customElements.get('ml-inspiration-gallery')) {
    customElements.define('ml-inspiration-gallery', MlInspirationGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml_section-real-stories"] && !Shopify.designMode) return;
  try {
    
  class MlRealStories extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.pointerStartX = 0;
      this.pointerTracking = false;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(Number(dot.dataset.index));
        });
      });

      this.addEventListener('keydown', (event) => {
        if (this.slides.length < 2) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go((this.index + 1) % this.slides.length);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go((this.index - 1 + this.slides.length) % this.slides.length);
        }
      });

      const viewport = this.querySelector('[data-viewport]');
      if (viewport) {
        viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.pointerTracking = true;
          this.pointerStartX = event.clientX;
        });
        viewport.addEventListener('pointerup', (event) => {
          if (!this.pointerTracking) return;
          this.pointerTracking = false;
          const delta = event.clientX - this.pointerStartX;
          if (Math.abs(delta) < 40) return;
          if (delta < 0) this.go(Math.min(this.index + 1, this.slides.length - 1));
          else this.go(Math.max(this.index - 1, 0));
        });
        viewport.addEventListener('pointercancel', () => {
          this.pointerTracking = false;
        });
      }
    }

    go(index) {
      if (!this.slides.length || !this.track) return;
      this.index = index;
      this.track.style.transform = `translateX(${index * -100}%)`;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
        dot.tabIndex = active ? 0 : -1;
      });
    }
  }

  if (!customElements.get('ml-real-stories')) {
    customElements.define('ml-real-stories', MlRealStories);
  }

  } catch(e) { console.error(e); }
})();
})();
